import { ChangeDetectionStrategy, Component, inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { GROWTHBOOK } from '../../../growthbook';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { sleep } from '../../../lib/sleep';
import { BoxFile } from '../../../services/box.service';
import { OnGetData } from '../../../services/dialog.service';

@Component({
  selector: 'app-box-picker-wrapper-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [],
  templateUrl: './box-picker-wrapper-dialog.component.html',
  styleUrl: './box-picker-wrapper-dialog.component.scss',
})
export class BoxPickerWrapperDialogComponent implements OnGetData, OnDestroy {
  private growthBook = inject(GROWTHBOOK);
  dialogName = 'box-picker-wrapper';
  close: (files: BoxFile[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filePicker: any;

  dialogOptions(): DialogOptions {
    return {
      hideClose: true,
      spacingX: 0,
      spacingY: 0,
      size: 640,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async onGetData(data: { filePicker: any; accessToken: string }, close: (files: BoxFile[]) => void) {
    this.close = close;
    this.filePicker = data.filePicker;

    this.filePicker.addListener('choose', async items => {
      this.close(
        items.map(item => {
          return {
            name: item.name,
            url: item.authenticated_download_url,
            size: item.size,
            source: 'box',
          };
        })
      );
    });

    this.filePicker.addListener('cancel', () => {
      this.close(undefined);
    });

    await sleep(0);
    const extensions = [
      ...this.growthBook.getFeatureValue('allowed_upload_file_types', []),
      ...this.growthBook.getFeatureValue('allowed_upload_file_types_video', []),
      ...this.growthBook.getFeatureValue('allowed_upload_file_types_raw', []),
      ...this.growthBook.getFeatureValue('allowed_upload_file_types_document', []),
      ...this.growthBook.getFeatureValue('allowed_upload_file_types_non_preview', []),
    ];
    this.filePicker['show']('0', data.accessToken, {
      container: '#box-file-picker',
      extensions,
      logoUrl: 'box',
    });
  }

  ngOnDestroy(): void {
    this.filePicker.removeAllListeners();
  }
}
